var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgThumbUp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.33465 10.9501L10.6024 1.5C11.4513 1.5 12.2654 1.83188 12.8657 2.42263C13.4659 3.01338 13.8032 3.8146 13.8032 4.65005V8.85011H19.842C20.1513 8.84666 20.4577 8.90944 20.7399 9.03409C21.0221 9.15874 21.2734 9.34229 21.4764 9.57201C21.6793 9.80173 21.8291 10.0721 21.9154 10.3645C22.0016 10.6569 22.0223 10.9642 21.9758 11.2651L20.5035 20.7153C20.4263 21.216 20.1679 21.6725 19.7757 22.0005C19.3836 22.3285 18.8842 22.506 18.3696 22.5003H6.33465M6.33465 10.9501V22.5003M6.33465 10.9501H3.13386C2.56792 10.9501 2.02517 11.1714 1.62499 11.5652C1.22482 11.9591 1 12.4932 1 13.0502V20.4003C1 20.9572 1.22482 21.4914 1.62499 21.8852C2.02517 22.2791 2.56792 22.5003 3.13386 22.5003H6.33465",
    stroke: "#41953F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbUp);
export default __webpack_public_path__ + "static/media/thumb-up.b60f7015d0cdb8888e7cfd864dbfd76d.svg";
export { ForwardRef as ReactComponent };